import { Dispatch } from 'redux'

import * as Api from 'redux/api/Applications/StandardModels/v3'
import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

/**
 * Activate the standard information model for the signed in customer. The
 * created ontology is put straight into the SIM slice so the overview populates
 * without a refetch.
 */
function tryActivateStandardModel() {
  return (dispatch: Dispatch) => {
    dispatch(actions.activateStandard())

    return Api.activateStandard()
      .then((response) => {
        dispatch(actions.activateStandardSuccess(response.data.data))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.activateStandardFailed())
        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useStandardModelActions = () => ({
  tryActivateStandardModel: useThunkActions(tryActivateStandardModel)
})
